import { selectors, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { invokeEvent } from 'shared-base';
import { ExitRealtime } from './ExitRealtime';

export type ExitRealtimeContainerProps = {};

export function ExitRealtimeContainer(_props: ExitRealtimeContainerProps) {
  const realtimeState = useSelector(selectors.raw.$rawRealtimeState);
  const { isEnabled, isReady } = realtimeState;

  const callbacks = useMemo(
    () => ({
      onClick: () => {
        invokeEvent('REALTIME', { verb: 'stop' });
      },
    }),
    []
  );

  if (!isEnabled) {
    return null;
  }

  return <ExitRealtime isReady={isReady} onClick={callbacks.onClick} />;
}

export default ExitRealtimeContainer;
